export default "__VITE_ASSET__0fd82f64__"